import { render, staticRenderFns } from "./avg-modal.vue?vue&type=template&id=025fa5d5&scoped=true"
import script from "./avg-modal.vue?vue&type=script&lang=js"
export * from "./avg-modal.vue?vue&type=script&lang=js"
import style0 from "./avg-modal.vue?vue&type=style&index=0&id=025fa5d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025fa5d5",
  null
  
)

export default component.exports